import { Typography } from "@octopus-energy/coral/atoms"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { animate, motion, useSpring, useTransform } from "framer-motion"
import { type SbBlokAnimatedNumber } from "../types"

type DynamicAnimatedNumberProps = {
    blok: SbBlokAnimatedNumber
}

export function DynamicAnimatedNumber({ blok }: DynamicAnimatedNumberProps) {
    const count = useSpring(0, { mass: 0.8, stiffness: 75, damping: 15 })
    const rounded = useTransform(count, (latest) => Math.round(latest).toLocaleString())
    const target = Number(blok.target) ?? 0

    if (!blok?.target) {
        return (
            <StoryblokMissingField
                blok="Animated Number"
                field="Target"
            />
        )
    }

    const animateCount = () => {
        void animate(count, target, {
            duration: 3,
        })
    }

    return (
        <Typography component="div">
            <motion.span onViewportEnter={animateCount}>{rounded}</motion.span>
            {blok.suffix}
        </Typography>
    )
}

export default DynamicAnimatedNumber
